import router from "@/router";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // progress bar
import { getToken } from "@/utils/auth"; // get token from cookie
import { usePermissionStore, useUserStore } from "@/store";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const loginPage = "/login";
const whiteList = [
  loginPage,
  "/set-password", //パスワード設定画面
  "/reset-password", //パスワード再発行画面
  "/terms", //利用規約画面
  "/link/docs", //ドキュメント一覧画面
  "/link/toiawase-form", //問い合わせ画面
];

router.beforeEach(async (to, from, next) => {
  const token = getToken();
  const userStore = useUserStore();
  const permissionStore = usePermissionStore();
  const hasRole = userStore.getRole;

  NProgress.start();
  if (!token) {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      await userStore.resetToken();
      next(`${loginPage}?redirect=${to.path}`);
    }
    return;
  }

  if (to.path === loginPage) {
    next({ path: "/" });
  } else if (hasRole) {
    next();
  } else {
    try {
      const { role } = await userStore.getInfoAction(token);
      const accessRoutes = await permissionStore.generateRoutes(role);
      //動的にアクセスできるrouteを追加
      accessRoutes.forEach((route) => {
        router.addRoute(route);
      });
      console.log("permission accessRoutes", accessRoutes);
      console.log("permission getrouter:", router, to);
      next({ ...to, replace: true });
    } catch (error) {
      await userStore.resetToken();
      next(`${loginPage}?redirect=${to.path}`);
      console.log(error);
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
